import { render } from "./AlienPlayerScoutReportView.vue?vue&type=template&id=433d3969"
import script from "./AlienPlayerScoutReportView.vue?vue&type=script&lang=js"
export * from "./AlienPlayerScoutReportView.vue?vue&type=script&lang=js"

import "./AlienPlayerScoutReportView.vue?vue&type=style&index=0&id=433d3969&lang=scss"

import exportComponent from "/home/misha/Рабочий стол/sportkit-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__